var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlotDimension = function SvgPlotDimension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plot_dimension_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M13.412.703h7.766v34.594h-7.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M14.115 36V0H8.473v36z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21.177 3.527h-4.236M21.178 6.352h-2.825M21.177 9.176h-4.236M21.178 12h-2.825M21.177 14.824h-4.236M21.178 17.648h-2.825M21.177 20.473h-4.236M21.178 23.297h-2.825M21.177 26.117h-4.236M21.178 28.941h-2.825M21.177 31.766h-4.236M24.002.703h2.824M25.414.703v34.594M26.826 35.297h-2.824"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plot_dimension_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgPlotDimension;